import * as LocationEffects from './location.effect';

export const effects = { ...LocationEffects };
